import type {LocaleV3} from '@smart/locale-service';

export const getLanguageMappedPaths = (
  paths: ReadonlyArray<string>,
  locale: LocaleV3,
) => {
  const basePath = `/${locale.language}`;
  return [...paths].map((path) => `${basePath}${path}`);
};
